<template>
	<div>
		<MobileHeader v-if="isMobile"></MobileHeader>
		<div v-else class="nav">
			<div class="logo" @click="routerJump('/home')">
				<img
					src="https://oss.cuttlefish.vip/file/h5upload/178884522481666349681.png"
					alt="墨鱼旅行"
				/>
			</div>
			<ul class="nav-list">
				<li
					v-for="item in navList"
					:key="item.id"
					class="nav-item"
					:class="{ active: isNavActive(item), 'has-children': item.children }"
					@click="item.path && routerJump(item.path)"
				>
					<span>{{ item.name }}</span>
					<span v-if="item.children" class="nav-arrow"></span>
					<ul v-if="item.children" class="nav-submenu" @click.stop>
						<li
							v-for="child in item.children"
							:key="child.id"
							:class="{ active: path === child.path }"
							@click="routerJump(child.path)"
						>
							{{ child.name }}
						</li>
					</ul>
				</li>
			</ul>
		</div>
		<router-view></router-view>
		<div v-if="showContactSection" class="contact-us">
			<div class="contact-us-title">联系我们</div>
			<div class="contact-us-content">
				<div class="contact-us-item">
					<span class="contact-us-left">客服热线</span
					><span class="contact-us-right">400 886 9966</span>
				</div>
				<div class="contact-us-item">
					<span class="contact-us-left">官方邮箱</span
					><span class="contact-us-right">moyu@moyu-travel.com</span>
				</div>
				<div class="contact-us-item">
					<span class="contact-us-left">总部办公地址</span
					><span class="contact-us-right">上海市杨浦区杨树浦路658号中交滨江广场A座19楼</span>
				</div>
			</div>
		</div>
		<div v-show="path !== '/login'" class="footer">
			<div class="footer-content">
				<div @click="goKeepOnRecord" class="footer-content-left">
					{{ keepOnRecordObj.title }}
				</div>
				<div class="footer-content-right">
					<div
						@click="goKeepOnRecord"
						class="keep-on-record-icon"
						:style="{ backgroundImage: `url(${keepOnRecordObj.picPath})` }"
					></div>
					<span @click="goKeepOnRecord" class="keep-on-record-number">{{
						keepOnRecordObj.content
					}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { articleTagList } from "@/http/api";
	import MobileHeader from "@/components/MobileHeader.vue";
	export default {
		components: {
			MobileHeader,
		},
		data() {
			return {
				isMobile: this.$isMobile,
				path: "",
				color: "#333",
				navList: [
					{ id: 1, name: "首页", path: "/home" },
					{ id: 2, name: "定制游", path: "/customTour" },
					{ id: 3, name: "驴友社区", path: "/travelCommunity" },
					{ id: 4, name: "组队", path: "/goWith" },
					{ id: 5, name: "热门路线", path: "/hotRoute" },
					{ id: 6, name: "关于墨鱼", path: "/appDownload" },
					{
						id: 7,
						name: "公司介绍",
						children: [
							{ id: 71, name: "平台介绍", path: "/platformIntro" },
							{ id: 72, name: "创始人介绍", path: "/founderIntro" },
						],
					},
				],
				keepOnRecordObj: {
					picPath:
						"https://oss.cuttlefish.vip/file/backstageManagement/serveManage/1661233212930.png",
					url: "https://beian.miit.gov.cn/",
					title: "备案号：沪ICP备18044950号-1",
					content: "沪公网安备 31011302005786号",
				},
			};
		},
		computed: {
			showContactSection() {
				return this.path === "/home" || this.path === "/appDownload";
			},
		},
		created() {
			this.getArticleTagList();
		},
		mounted() {
			this.path = this.$route.path;
			this.logoType();
		},
		methods: {
			routerJump(path) {
				this.$router.push(path);
				this.logoType();
			},
			logoType() {
				this.color = "#333";
			},
			isNavActive(item) {
				if (item.path) {
					return this.path === item.path;
				}
				return item.children && item.children.some((child) => child.path === this.path);
			},
			// 获取备案信息
			async getArticleTagList() {
				const { data: res } = await articleTagList({
					nid: "os_keep_on_record",
				});
				if (res.code === 200 && res.data.length > 0) {
					if (!res.data[0].picPath.startsWith("http")) {
						res.data[0].picPath = this.$oss + res.data[0].picPath;
					}
					this.keepOnRecordObj = {
						picPath: res.data[0].picPath,
						url: res.data[0].introduction,
						title: res.data[0].title,
						content: res.data[0].content,
					};
				}
			},
			// 打开备案网站
			goKeepOnRecord() {
				open(this.keepOnRecordObj.url);
			},
		},
		watch: {
			$route(route) {
				this.path = route.path;
				this.logoType();
			},
		},
	};
</script>

<style scope lang="scss">
	.nav {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding: 0 120px;
		width: 100%;
		height: 122px;
		z-index: 999;
		background-color: #fff;
		box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
		.logo {
			cursor: pointer;
			height: 48px;
			img {
				display: block;
				height: 48px;
				width: auto;
			}
		}
		.nav-list {
			display: flex;
			margin: 0;
			padding: 0;
			height: 42px;
			list-style: none;

			.nav-item {
				position: relative;
				display: flex;
				align-items: center;
				margin-right: 38px;
				font-size: 18px;
				font-weight: 500;
				color: #333;
				cursor: pointer;
				transition: color 0.2s ease;

				&:last-child {
					margin-right: 0;
				}

				&:hover,
				&.active {
					color: #26a1ff;
				}

				&.has-children {
					cursor: default;
				}

				.nav-arrow {
					margin: -4px 0 0 8px;
					width: 7px;
					height: 7px;
					border-right: 1px solid currentColor;
					border-bottom: 1px solid currentColor;
					transform: rotate(45deg);
					transition: transform 0.2s ease;
				}

				.nav-submenu {
					position: absolute;
					top: 42px;
					left: 50%;
					z-index: 1001;
					box-sizing: border-box;
					margin: 0;
					padding: 10px 0;
					min-width: 150px;
					border: 1px solid #edf1f5;
					border-radius: 10px;
					background: #fff;
					box-shadow: 0 12px 32px rgba(18, 63, 95, 0.14);
					list-style: none;
					opacity: 0;
					visibility: hidden;
					pointer-events: none;
					transform: translate(-50%, 8px);
					transition: opacity 0.2s ease, transform 0.2s ease,
						visibility 0.2s ease;

					li {
						box-sizing: border-box;
						padding: 13px 22px;
						width: 100%;
						font-size: 16px;
						font-weight: 400;
						color: #333;
						text-align: center;
						white-space: nowrap;
						cursor: pointer;
						transition: color 0.2s ease, background 0.2s ease;

						&:hover,
						&.active {
							color: #26a1ff;
							background: #f2f9ff;
						}
					}
				}

				&:last-child .nav-submenu {
					right: 0;
					left: auto;
					transform: translate(0, 8px);
				}

				&.has-children:hover {
					.nav-arrow {
						transform: rotate(225deg);
					}

					.nav-submenu {
						opacity: 1;
						visibility: visible;
						pointer-events: auto;
						transform: translate(-50%, 0);
					}
				}

				&.has-children:last-child:hover .nav-submenu {
					transform: translate(0, 0);
				}
			}
		}
	}
	.contact-us {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
		margin-bottom: 0;
		padding: 48px 24px 24px;
		text-align: center;
		.contact-us-title {
			margin-bottom: 58px;
			font-size: 28px;
			font-weight: 800;
			color: #333;
		}
		.contact-us-content {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 100%;
		}
		.contact-us-item {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 40px;
			&:last-child {
				margin-bottom: 0;
			}
			.contact-us-left {
				flex-shrink: 0;
				margin-right: 42px;
				font-size: 20px;
				font-weight: 400;
				font-family: PingFangSC-Regular, PingFang SC;
				color: #999999;
				white-space: nowrap;
			}
			.contact-us-right {
				font-size: 20px;
				font-family: PingFang-SC-Heavy, PingFang-SC;
				font-weight: 600;
				color: #333333;
				text-align: center;
				word-break: break-word;
			}
		}
	}
	@media screen and (max-width: 768px) {
		.contact-us {
			padding: 40px 16px 32px;
		}
	}
	.footer {
		overflow: hidden;
		height: 188px;
		background: #063b63;
		.footer-content {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 133px;
			font-size: 14px;
			color: #fff;
			font-family: PingFangSC-Regular, PingFang SC;
			.footer-content-left {
				cursor: pointer;
			}
			.footer-content-right {
				display: flex;
				align-items: center;
				margin-left: 63px;

				.keep-on-record-icon {
					margin-right: 8px;
					width: 20px;
					height: 20px;
					background-size: 100% 100%;
					cursor: pointer;
				}
				.keep-on-record-number {
					cursor: pointer;
				}
			}
		}
	}
</style>